import ApiService from "./apiService";

class TmcApplicationsService {
  static newApplications(data) {
    return ApiService.post("/tmcApplications/newApplication", data);
  }

  static getAllApplications(data) {
    return ApiService.request("get", "/tmcApplications/getAllApplications", data);
  }

  static updateApplications(data) {
    return ApiService.put("/tmcApplications/updateApplications", data);
  }
}

export default TmcApplicationsService;
